<template>
<div class="modal fade" tabindex="-1" role="dialog" id="resetPasswordModal">
  <div class="modal-dialog" role="document">
    <div class="box k6-modal-container">
      <div>
        <img src="../../assets/reset_password.svg" style="height: 200px; width: 350px"/>
      </div>
      <div class="text-center">
        <h2 style="font-weight: bold;">{{ $t("pages.resetPassword.title") }}</h2>
        <p>{{ $t("pages.resetPassword.description") }}</p>
      </div>
      
      <form class="form-horizontal">
          <div style="display: flex; justify-content: center;">
            <input v-model="email" type="email" class="form-control text-center rounded-action"
            id="email" :placeholder="$t('pages.register.email')" autofocus>
          </div>
          <div class="text-center">
            <button @click.prevent="submitData" type="submit" style="font-size: 16px"
              class="k6-primary-btn rounded-action">{{$t('pages.resetPassword.resetMsg')}}</button>
          </div>
      </form>
    </div>
  </div>
</div>

</template>

<script>
  // import Vue from 'vue'
  import Rest from './../../services/rest'
  // import { mapState } from 'vuex'
  // import router from './../../router/router'

  export default {
    data () {
      return {
        email: '',
        resetMsg: ''
      }
    },
    methods: {
      submitData () {
        var postdata = {
          email: this.email
        }
        return Rest.request('POST', '/users/emails/resetPassword', postdata).then((data) => {
          this.resetMsg = this.$t('pages.resetPassword.successMsg')
          const { message } = data
          if (message === 'Password reset email sent.') {
            window.jQuery('#resetPasswordModal').modal('toggle')
          } else {
            Rest.Vue.$snotify.error(message)
          }
        }).catch(function (err) {
          console.err(err)
          this.resetMsg = err.responseJSON['message'] // TODO: translate
        })
      }
    }
  }
</script>

<style scoped>
.box {
  padding: 20px;
}

.rounded-action {
  width: 300px !important;
  border-radius: 20px !important;
  margin: 10px !important;
}

</style>



// WEBPACK FOOTER //
// ResetPassword.vue?419588f8